import axiosInstance from '../../../../config/axiosInstance';
import { AgreementValidation } from "../../../Setup/views/Agreement/Validation/AgreementValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (formData, setFormData, setErrors, redirectCallback, redirectUserList) => {
  const formErrors = AgreementValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const response = await axiosInstance.post(`/SuperAdmin/UpdateCompany`, formData);
      if (response.data) {
        setFormData(response.data);
      }
      redirectUserList();
    } catch (error) {
      if (error.response.data.message === "Invalid token") {
        redirectCallback();
        return;
      }
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };
